//LL: 27.02.18: copy to Charts/components from common/application

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

declare var require: any;

//import EditComponent from '../../../_common/application/tsx/ChartCustomStylesField';  //LL 11.01.18
import EditComponent from './ChartCustomStylesField'; //LL 27.02.18

export class ChartCustomStylesField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = ChartCustomStylesField.getDefaultValue();
        }

        super(glob, title, ChartCustomStylesField.defaultValidators, validators, defaultVal, options);
    }
}
